export function formatCurrencyFallback(num: number) {
  return '$' + (num?.toFixed(2) || 0);
}
